// SettingEngineState.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import ModalSetBool from '../SettingPageComponents/ModalSetBool'
import ModalSetBool2 from '../SettingPageComponents/ModalSetBool2'
import colors from '../../../../css/colors.module.css'

const isNumber = x => !isNaN(x) && isFinite(x)

export const SettingModbusStart = function SettingModbusStart ({
  device,
  status,
  level,
  customer,
  pinCode,
}) {
  const MACHINE_STATE = (
    <FormattedMessage
      id='device.machineState.name'
      defaultMessage='Machine State'
      description='Machine State Label'
    />
  )
  let engineState = '-'
  let tileColor = colors.normal
  let engineStateNew = 0
  let engineStateTransition = 0
  const reading0 = device.reading0 || {}
  const applicationSettingsNew = device.application_settings_new || { settings: {} }
  let engineStateIntention = reading0['131'] || 0

  if (
    applicationSettingsNew &&
    applicationSettingsNew.settings &&
    (applicationSettingsNew.settings.run === 1 ||
     applicationSettingsNew.settings.run === 0)
  ) {
    if (applicationSettingsNew.status === 'new') {
      engineStateNew = applicationSettingsNew.settings.run ? 1 : 2
      engineStateIntention = applicationSettingsNew.settings.run
    }
    /*
      This is supposed to cover the transition period between sending stop command
      and it actually getting implemented on the wind machine.
        - command is set in web app, turns red and shows stop
        - device gets command and responds to web, which changes to onDevice
        - device implements command with mpc20 or hauff machine
        - ... time ...
        - device sends follow up reading with new machine state

    */
    if (
      applicationSettingsNew.status === 'onDevice' &&
      ((new Date()).getTime() - (1000 * 65)) < (new Date(applicationSettingsNew.date)).getTime() &&
      (reading0['140'] >= 10 && reading0['140'] <= 12)
    ) {
      engineStateTransition = applicationSettingsNew.settings.run ? 1 : 2
      engineStateIntention = applicationSettingsNew.settings.run
    }
  }

  /*

      enum MPC20_STATES {
        STATE_NOT_CONNECTED       = 20,
        STATE_ECU_DELAY           = 0,
        STATE_ENGINE_STOPPED      = 1,
        STATE_CONTROLLER_STANDBY  = 2,
        STATE_PRESTART_DELAY_1    = 3,
        STATE_CHECK_SAFE          = 4,
        STATE_PRESTART_DELAY_2    = 5,
        STATE_CRANK_ON            = 6,
        STATE_CRANK_REST          = 7,
        STATE_FALSE_START         = 8,
        STATE_WARMUP_DELAY        = 9,
        STATE_LINE_FILL_1         = 10,
        STATE_LINE_FILL_2         = 11,
        STATE_RUNNING_LOADED      = 12,
        STATE_COOLDOWN_DELAY      = 13,
        STATE_ENERGIZE_TO_STOP    = 14,
        STATE_SPINDOWN_DELAY      = 15
      };

  */
  const MACHINE_OFF = (
    <FormattedMessage
      id='device.machineState.off'
      defaultMessage='OFF'
      description='OFF State'
    />
  )
  const MACHINE_RUN = (
    <FormattedMessage
      id='device.machineState.run'
      defaultMessage='RUN'
      description='RUN State'
    />
  )
  const MACHINE_START = (
    <FormattedMessage
      id='device.machineState.start'
      defaultMessage='START'
      description='START State'
    />
  )
  const MACHINE_STOP = (
    <FormattedMessage
      id='device.machineState.stop'
      defaultMessage='STOP'
      description='STOP State'
    />
  )
  const MACHINE_WARMUP = (
    <FormattedMessage
      id='device.machineState.warmUp'
      defaultMessage='WARMUP'
      description='WARMUP State'
    />
  )
  const MACHINE_FULLRUN = (
    <FormattedMessage
      id='device.machineState.fullRun'
      defaultMessage='FULL RUN'
      description='FULL RUN State'
    />
  )
  const MACHINE_COOLDOWN = (
    <FormattedMessage
      id='device.machineState.coolDown'
      defaultMessage='COOL DOWN'
      description='COOL DOWN State'
    />
  )
  switch (reading0['140']) {
    case 0:
    case 1:
    case 2:
      engineState = MACHINE_OFF
      if (engineStateTransition) { engineState = engineStateTransition === 2 ? MACHINE_OFF : MACHINE_RUN }
      tileColor = colors.normal
      break
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
      engineState = MACHINE_START
      if (engineStateTransition) { engineState = engineStateTransition === 2 ? MACHINE_STOP : MACHINE_START }
      tileColor = colors.info
      break
    case 9:
      engineState = MACHINE_WARMUP
      if (engineStateTransition) { engineState = engineStateTransition === 2 ? MACHINE_STOP : MACHINE_WARMUP }
      tileColor = colors.info
      break
    case 10:
    case 11:
    case 12:
      engineState = MACHINE_FULLRUN
      if (engineStateTransition) { engineState = engineStateTransition === 2 ? MACHINE_STOP : MACHINE_FULLRUN }
      tileColor = colors.success
      break
    case 13:
    case 14:
    case 15:
    case 16:
      engineState = MACHINE_COOLDOWN
      if (engineStateTransition) { engineState = engineStateTransition === 2 ? MACHINE_COOLDOWN : MACHINE_RUN }
      tileColor = colors.info
      break
    default:
      engineState = '-'
      tileColor = colors.danger
  }

  if (engineStateNew) {
    tileColor = colors.deviceProblem
    engineState = engineStateNew === 2 ? MACHINE_STOP : MACHINE_RUN
  }

  const controllerStatusModbus = ((reading0['144'] & 0xFF) >>> 0) - 10
  let modalEnable = true
  if (level >= 10) {
    if (
      controllerStatusModbus < 1 ||
      status.id === 'notConnected'
    ) {
      modalEnable = false
    } else if (!engineStateIntention) {
      modalEnable = false
    }
  } else {
    modalEnable = false
  }

  if (
    controllerStatusModbus < 1 ||
    status.id === 'notConnected'
  ) {
    engineState = '-'
    tileColor = colors.normal
  }

  return (
    <ModalSetBool
      key='settingModbusStart'
      name='settingModbusStart'
      textPrimary={engineState}
      textSecondary={MACHINE_STATE}
      textModal={(
        <FormattedMessage
          id='device.machineState.modalInfo'
          defaultMessage='Remote {action} {device}?'
          description='Machine State modal info text'
          values={{
            action: (engineStateIntention === 0 ? MACHINE_START : MACHINE_STOP),
            device: device.physical.deviceNumber,
          }}
        />
      )}
      textSave={engineStateIntention === 0 ? MACHINE_START : MACHINE_STOP}
      tileColor={tileColor}
      settingName='run'
      settingNewValue={engineStateIntention ? 0 : 1}
      address={reading0.address}
      warning={!engineStateIntention}
      warningText={(
        <FormattedMessage
          id='device.machineState.modalWarning'
          defaultMessage='You are attempting to start the selected machine. Click OK if the machine is in operating condition and all personnel are clear of the machine.'
          description='Machine State modal warning text'
        />
      )}
      enable={modalEnable}
      customer={customer}
      pinCode={pinCode}
    />
  )
}

SettingModbusStart.propTypes = {
  device: PropTypes.object,
  status: PropTypes.object,
  level: PropTypes.number,
  customer: PropTypes.object,
  pinCode: PropTypes.object,
}

export const SettingEngineState = function SettingEngineState ({
  device,
  status,
  level,
  customer,
  pinCode,
}) {
  const MACHINE_STATE = (
    <FormattedMessage
      id='device.machineState.name'
      defaultMessage='Machine State'
      description='Machine State Label'
    />
  )

  let engineState = '-'
  let tileColor = colors.normal
  let engineStateNew = 0
  let engineStateTransition = 0
  const reading0 = device.reading0 || {}
  const applicationSettingsNew = device.application_settings_new || { settings: {} }
  let engineStateIntention = reading0['131'] || 0

  const engineStateRaw = reading0['140']

  if (
    applicationSettingsNew &&
    applicationSettingsNew.settings &&
    (
      applicationSettingsNew.settings.run === 1 ||
      applicationSettingsNew.settings.run === 0
    )
  ) {
    if (applicationSettingsNew.status === 'new') {
      engineStateNew = applicationSettingsNew.settings.run ? 1 : 2
      engineStateIntention = applicationSettingsNew.settings.run
    }
    /*
      This is supposed to cover the transition period between sending stop command
      and it actually getting implemented on the wind machine.
        - command is set in web app, turns red and shows stop
        - device gets command and responds to web, which changes to onDevice
        - device implements command with mpc20 or hauff machine
        - ... time ...
        - device sends follow up reading with new machine state

    */
    if (
      applicationSettingsNew.status === 'onDevice' &&
      ((new Date()).getTime() - (1000 * 65)) < (new Date(applicationSettingsNew.date)).getTime() &&
      (engineStateRaw >= 10 && engineStateRaw <= 12)
    ) {
      engineStateTransition = applicationSettingsNew.settings.run ? 1 : 2
      engineStateIntention = applicationSettingsNew.settings.run
    }
  }

  /*

      enum MPC20_STATES {
        STATE_NOT_CONNECTED       = 20,
        STATE_ECU_DELAY           = 0,
        STATE_ENGINE_STOPPED      = 1,
        STATE_CONTROLLER_STANDBY  = 2,
        STATE_PRESTART_DELAY_1    = 3,
        STATE_CHECK_SAFE          = 4,
        STATE_PRESTART_DELAY_2    = 5,
        STATE_CRANK_ON            = 6,
        STATE_CRANK_REST          = 7,
        STATE_FALSE_START         = 8,
        STATE_WARMUP_DELAY        = 9,
        STATE_LINE_FILL_1         = 10,
        STATE_LINE_FILL_2         = 11,
        STATE_RUNNING_LOADED      = 12,
        STATE_COOLDOWN_DELAY      = 13,
        STATE_ENERGIZE_TO_STOP    = 14,
        STATE_SPINDOWN_DELAY      = 15
      };

  */
  const MACHINE_OFF = (
    <FormattedMessage
      id='device.machineState.off'
      defaultMessage='OFF'
      description='OFF State'
    />
  )
  const MACHINE_RUN = (
    <FormattedMessage
      id='device.machineState.run'
      defaultMessage='RUN'
      description='RUN State'
    />
  )
  const MACHINE_START = (
    <FormattedMessage
      id='device.machineState.start'
      defaultMessage='START'
      description='START State'
    />
  )
  const MACHINE_STOP = (
    <FormattedMessage
      id='device.machineState.stop'
      defaultMessage='STOP'
      description='STOP State'
    />
  )
  const MACHINE_WARMUP = (
    <FormattedMessage
      id='device.machineState.warmUp'
      defaultMessage='WARMUP'
      description='WARMUP State'
    />
  )
  const MACHINE_FULLRUN = (
    <FormattedMessage
      id='device.machineState.fullRun'
      defaultMessage='FULL RUN'
      description='FULL RUN State'
    />
  )
  const MACHINE_COOLDOWN = (
    <FormattedMessage
      id='device.machineState.coolDown'
      defaultMessage='COOL DOWN'
      description='COOL DOWN State'
    />
  )
  switch (engineStateRaw) {
    case 0:
    case 1:
    case 2:
      engineState = MACHINE_OFF
      if (engineStateTransition) { engineState = engineStateTransition === 2 ? MACHINE_OFF : MACHINE_RUN }
      tileColor = colors.normal
      break
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
      engineState = MACHINE_START
      if (engineStateTransition) { engineState = engineStateTransition === 2 ? MACHINE_STOP : MACHINE_START }
      tileColor = colors.info
      break
    case 9:
      engineState = MACHINE_WARMUP
      if (engineStateTransition) { engineState = engineStateTransition === 2 ? MACHINE_STOP : MACHINE_WARMUP }
      tileColor = colors.info
      break
    case 10:
    case 11:
    case 12:
      engineState = MACHINE_FULLRUN
      if (engineStateTransition) { engineState = engineStateTransition === 2 ? MACHINE_STOP : MACHINE_FULLRUN }
      tileColor = colors.success
      break
    case 13:
    case 14:
    case 15:
    case 16:
      engineState = MACHINE_COOLDOWN
      if (engineStateTransition) { engineState = engineStateTransition === 2 ? MACHINE_COOLDOWN : MACHINE_RUN }
      tileColor = colors.info
      break
    default:
      engineState = '-'
      tileColor = colors.danger
  }

  if (engineStateNew) {
    tileColor = colors.deviceProblem
    engineState = engineStateNew === 2 ? MACHINE_STOP : MACHINE_RUN
  }

  const controllerStatusAuto = reading0['143'] > 9000 ? 1 : 0
  let modalEnable = true
  if (level >= 10) {
    if (
      controllerStatusAuto < 1 ||
      status.id === 'notConnected'
    ) {
      modalEnable = false
    } else if (!engineStateIntention) {
      // don't enable modal when we could start engine
      modalEnable = false
    }
  } else {
    modalEnable = false
  }

  if (
    // controllerStatusAuto < 1 ||
    status.id === 'notConnected'
  ) {
    engineState = '-'
    tileColor = colors.normal
  }

  return (
    <ModalSetBool
      key='settingModbusStart'
      name='settingModbusStart'
      textPrimary={engineState}
      textSecondary={MACHINE_STATE}
      textModal={(
        <FormattedMessage
          id='device.machineState.modalInfo'
          defaultMessage='Remote {action} {device}?'
          description='Machine State modal info text'
          values={{
            action: (engineStateIntention === 0 ? MACHINE_START : MACHINE_STOP),
            device: device.physical.deviceNumber,
          }}
        />
      )}
      textSave={engineStateIntention === 0 ? MACHINE_START : MACHINE_STOP}
      tileColor={tileColor}
      settingName='run'
      settingNewValue={engineStateIntention ? 0 : 1}
      address={reading0.address}
      warning={!engineStateIntention}
      warningText={(
        <FormattedMessage
          id='device.machineState.modalWarning'
          defaultMessage='You are attempting to start the selected machine. Click OK if the machine is in operating condition and all personnel are clear of the machine.'
          description='Machine State modal warning text'
        />
      )}
      enable={modalEnable}
      customer={customer}
      pinCode={pinCode}
    />
  )
}

SettingEngineState.propTypes = {
  device: PropTypes.object,
  status: PropTypes.object,
  level: PropTypes.number,
  customer: PropTypes.object,
  pinCode: PropTypes.object,
}

export const SettingPumpState = function SettingPumpState ({
  device,
  status,
  level,
  customer,
  pinCode,
}) {
  const MACHINE_STATE = (
    <FormattedMessage
      id='device.machineState.name'
      defaultMessage='Machine State'
      description='Machine State Label'
    />
  )

  let machineState = '-'
  let tileColor = colors.normal
  let machineStateNew = 0
  let machineStateTransition = 0
  const reading0 = device.reading0 || {}
  const controllerStatusAuto = reading0['143'] > 9000 ? 1 : 0
  const applicationSettingsNew = device.application_settings_new || { settings: {} }
  let machineStateIntention = reading0['131'] || 0

  const machineStateRaw = reading0['140']

  if (
    applicationSettingsNew &&
    applicationSettingsNew.settings &&
    (
      applicationSettingsNew.settings.run === 1 ||
      applicationSettingsNew.settings.run === 0
    )
  ) {
    if (applicationSettingsNew.status === 'new') {
      machineStateNew = applicationSettingsNew.settings.run ? 1 : 2
      machineStateIntention = applicationSettingsNew.settings.run
    }
    /*
      This is supposed to cover the transition period between sending stop command
      and it actually getting implemented on the wind machine.
        - command is set in web app, turns red and shows stop
        - device gets command and responds to web, which changes to onDevice
        - device implements command with mpc20 or hauff machine
        - ... time ...
        - device sends follow up reading with new machine state

    */
    if (
      applicationSettingsNew.status === 'onDevice' &&
      ((new Date()).getTime() - (1000 * 65)) < (new Date(applicationSettingsNew.date)).getTime()
    ) {
      machineStateTransition = applicationSettingsNew.settings.run ? 1 : 2
      machineStateIntention = applicationSettingsNew.settings.run
    }
  }

  /*

      enum MPC20_STATES {
        STATE_NOT_CONNECTED       = 20,
        STATE_ECU_DELAY           = 0,
        STATE_ENGINE_STOPPED      = 1,
        STATE_CONTROLLER_STANDBY  = 2,
        STATE_PRESTART_DELAY_1    = 3,
        STATE_CHECK_SAFE          = 4,
        STATE_PRESTART_DELAY_2    = 5,
        STATE_CRANK_ON            = 6,
        STATE_CRANK_REST          = 7,
        STATE_FALSE_START         = 8,
        STATE_WARMUP_DELAY        = 9,
        STATE_LINE_FILL_1         = 10,
        STATE_LINE_FILL_2         = 11,
        STATE_RUNNING_LOADED      = 12,
        STATE_COOLDOWN_DELAY      = 13,
        STATE_ENERGIZE_TO_STOP    = 14,
        STATE_SPINDOWN_DELAY      = 15
      };

  */
  const MACHINE_OFF = (
    <FormattedMessage
      id='device.machineState.off'
      defaultMessage='OFF'
      description='OFF State'
    />
  ).valueOf()
  const MACHINE_RUN = (
    <FormattedMessage
      id='device.machineState.run'
      defaultMessage='RUN'
      description='RUN State'
    />
  )
  const MACHINE_START = (
    <FormattedMessage
      id='device.machineState.start'
      defaultMessage='START'
      description='START State'
    />
  )
  const MACHINE_WARMUP = (
    <FormattedMessage
      id='device.machineState.warmUp'
      defaultMessage='WARMUP'
      description='WARMUP State'
    />
  )
  const MACHINE_STOP = (
    <FormattedMessage
      id='device.machineState.stop'
      defaultMessage='STOP'
      description='STOP State'
    />
  )
  const MACHINE_FULLRUN = (
    <FormattedMessage
      id='device.machineState.fullRun'
      defaultMessage='FULL RUN'
      description='FULL RUN State'
    />
  )
  const MACHINE_COOLDOWN = (
    <FormattedMessage
      id='device.machineState.coolDown'
      defaultMessage='COOL DOWN'
      description='COOL DOWN State'
    />
  )
  switch (machineStateRaw) {
    case 0:
    case 1:
    case 2:
      machineState = MACHINE_OFF
      tileColor = colors.normal
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_OFF : MACHINE_START
        tileColor = machineStateTransition === 2 ? colors.normal : colors.info
      } else if (
        !controllerStatusAuto &&
        (
          (
            device.application_settings &&
            device.application_settings.settings &&
            device.application_settings.settings.run
          ) || (
            reading0 &&
            reading0['203'] > 0
          )
        )
      ) {
        machineState = MACHINE_RUN
        tileColor = colors.danger
        machineStateIntention = 1
      }
      break
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
      machineState = MACHINE_START
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_START
      }
      tileColor = colors.info
      break
    case 9:
      machineState = MACHINE_WARMUP
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_WARMUP
      }
      tileColor = colors.info
      break
    case 10:
    case 11:
    case 12:
      machineState = MACHINE_FULLRUN
      tileColor = colors.success
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_FULLRUN
        tileColor = machineStateTransition === 2 ? colors.info : colors.success
      }
      break
    case 13:
    case 14:
    case 15:
    case 16:
      machineState = MACHINE_STOP
      tileColor = colors.info
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_COOLDOWN
        tileColor = colors.info
      }
      break
    default:
      machineState = '-'
      tileColor = colors.danger
  }

  if (machineStateNew) {
    tileColor = colors.deviceProblem
    machineState = machineStateNew === 2 ? MACHINE_STOP : MACHINE_RUN
  }

  let modalEnable = false
  if (level >= 10) {
    modalEnable = true
    if (status.id === 'notConnected') { modalEnable = false }
  }

  if (
    status.id === 'notConnected'
  ) {
    machineState = '-'
    tileColor = colors.normal
  }

  return (
    <ModalSetBool
      key='settingPumpStart'
      name='settingPumpStart'
      textPrimary={machineState}
      textSecondary={MACHINE_STATE}
      textModal={`Remote ${machineStateIntention === 0 ? 'start' : 'stop'} ${device.physical.deviceNumber}?`}
      textSave={machineStateIntention === 0 ? MACHINE_START : MACHINE_STOP}
      tileColor={tileColor}
      settingName='run'
      settingNewValue={machineStateIntention ? 0 : 1}
      address={reading0.address}
      warning={!machineStateIntention}
      warningText={(
        <FormattedMessage
          id='device.machineState.modalWarning'
          defaultMessage='You are attempting to start the selected machine. Click OK if the machine is in operating condition and all personnel are clear of the machine.'
          description='Machine State modal warning text'
        />
      )}
      enable={modalEnable}
      customer={customer}
      pinCode={pinCode}
    />
  )
}

SettingPumpState.propTypes = {
  device: PropTypes.object,
  status: PropTypes.object,
  level: PropTypes.number,
  customer: PropTypes.object,
  pinCode: PropTypes.object,
}

export const SettingPumpState1 = function SettingPumpState1 ({
  device,
  status,
  level,
  customer,
  pinCode,
}) {
  const MACHINE_STATE = (
    <FormattedMessage
      id='device.machineState.name'
      defaultMessage='Machine State'
      description='Machine State Label'
    />
  )

  let machineState = '-'
  let tileColorRight = colors.normal
  let machineStateNew = 0
  let machineStateTransition = 0
  const runSetting = 'run'
  const reading0 = device.reading0 || {}
  const runSettingConfirm = '203'
  const controllerStatusAuto = reading0['143'] > 9000 ? 1 : 0
  const applicationSettingsNew = device.application_settings_new || { settings: {} }
  let machineStateIntention = reading0['131'] || 0

  const machineStateRaw = reading0['140']

  if (
    applicationSettingsNew &&
    applicationSettingsNew.settings &&
    (
      applicationSettingsNew.settings[runSetting] === 1 ||
      applicationSettingsNew.settings[runSetting] === 0
    )
  ) {
    if (applicationSettingsNew.status === 'new') {
      machineStateNew = applicationSettingsNew.settings[runSetting] ? 1 : 2
      machineStateIntention = applicationSettingsNew.settings[runSetting]
    }
    /*
      This is supposed to cover the transition period between sending stop command
      and it actually getting implemented on the wind machine.
        - command is set in web app, turns red and shows stop
        - device gets command and responds to web, which changes to onDevice
        - device implements command with mpc20 or hauff machine
        - ... time ...
        - device sends follow up reading with new machine state

    */
    if (
      applicationSettingsNew.status === 'onDevice' &&
      ((new Date()).getTime() - (1000 * 65)) < (new Date(applicationSettingsNew.date)).getTime()
    ) {
      machineStateTransition = applicationSettingsNew.settings[runSetting] ? 1 : 2
      machineStateIntention = applicationSettingsNew.settings[runSetting]
    }
  }

  /*

      enum MPC20_STATES {
        STATE_NOT_CONNECTED       = 20,
        STATE_ECU_DELAY           = 0,
        STATE_ENGINE_STOPPED      = 1,
        STATE_CONTROLLER_STANDBY  = 2,
        STATE_PRESTART_DELAY_1    = 3,
        STATE_CHECK_SAFE          = 4,
        STATE_PRESTART_DELAY_2    = 5,
        STATE_CRANK_ON            = 6,
        STATE_CRANK_REST          = 7,
        STATE_FALSE_START         = 8,
        STATE_WARMUP_DELAY        = 9,
        STATE_LINE_FILL_1         = 10,
        STATE_LINE_FILL_2         = 11,
        STATE_RUNNING_LOADED      = 12,
        STATE_COOLDOWN_DELAY      = 13,
        STATE_ENERGIZE_TO_STOP    = 14,
        STATE_SPINDOWN_DELAY      = 15
      };

  */
  const MACHINE_OFF = (
    <FormattedMessage
      id='device.machineState.off'
      defaultMessage='OFF'
      description='OFF State'
    />
  ).valueOf()
  const MACHINE_RUN = (
    <FormattedMessage
      id='device.machineState.run'
      defaultMessage='RUN'
      description='RUN State'
    />
  )
  const MACHINE_START = (
    <FormattedMessage
      id='device.machineState.start'
      defaultMessage='START'
      description='START State'
    />
  )
  const MACHINE_WARMUP = (
    <FormattedMessage
      id='device.machineState.warmUp'
      defaultMessage='WARMUP'
      description='WARMUP State'
    />
  )
  const MACHINE_STOP = (
    <FormattedMessage
      id='device.machineState.stop'
      defaultMessage='STOP'
      description='STOP State'
    />
  )
  const MACHINE_FULLRUN = (
    <FormattedMessage
      id='device.machineState.fullRun'
      defaultMessage='FULL RUN'
      description='FULL RUN State'
    />
  )
  const MACHINE_COOLDOWN = (
    <FormattedMessage
      id='device.machineState.coolDown'
      defaultMessage='COOL DOWN'
      description='COOL DOWN State'
    />
  )
  switch (machineStateRaw) {
    case 0:
    case 1:
    case 2:
      machineState = MACHINE_RUN
      tileColorRight = colors.normal
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_RUN : MACHINE_START
        tileColorRight = machineStateTransition === 2 ? colors.normal : colors.info
      } else if (
        !controllerStatusAuto &&
        (
          (
            device.application_settings &&
            device.application_settings.settings &&
            device.application_settings.settings[runSetting]
          ) || (
            reading0 &&
            reading0[runSettingConfirm] > 0
          )
        )
      ) {
        machineState = MACHINE_RUN
        tileColorRight = colors.danger
        machineStateIntention = 1
      }
      break
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
      machineState = MACHINE_START
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_START
      }
      tileColorRight = colors.info
      break
    case 8:
      machineState = MACHINE_START
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_START
      }
      tileColorRight = colors.danger
      break
    case 9:
      machineState = MACHINE_WARMUP
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_WARMUP
      }
      tileColorRight = colors.info
      break
    case 10:
    case 11:
    case 12:
      machineState = MACHINE_FULLRUN
      tileColorRight = colors.success
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_FULLRUN
        tileColorRight = machineStateTransition === 2 ? colors.info : colors.success
      }
      break
    case 13:
    case 14:
    case 15:
    case 16:
      machineState = MACHINE_STOP
      tileColorRight = colors.info
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_COOLDOWN
        tileColorRight = colors.info
      }
      break
    default:
      machineState = '-'
      tileColorRight = colors.danger
  }

  if (machineStateNew) {
    tileColorRight = colors.deviceProblem
    machineState = machineStateNew === 2 ? MACHINE_STOP : MACHINE_RUN
  }

  let modalEnable = false
  if (level >= 10) {
    modalEnable = true
    if (status.id === 'notConnected') { modalEnable = false }
  }

  if (
    status.id === 'notConnected'
  ) {
    machineState = '-'
    tileColorRight = colors.normal
  }

  return (
    <ModalSetBool2
      key='settingPumpStart'
      name='settingPumpStart'
      textLeft={MACHINE_OFF}
      textRight={machineState}
      textSub='State'
      tileColorLeft={colors.normal}
      tileColorRight={tileColorRight}
      settingCurrentValue={machineStateIntention ? 1 : 0}
      textModal={`Remote ${machineStateIntention === 0 ? 'start' : 'stop'} ${device.physical.deviceNumber}?`}
      textSave={machineStateIntention === 0 ? MACHINE_START : MACHINE_STOP}
      settingName={runSetting}
      settingNewValue={machineStateIntention ? 0 : 1}
      address={reading0.address}
      warning={!machineStateIntention}
      warningText={(
        <FormattedMessage
          id='device.machineState.modalWarning'
          defaultMessage='You are attempting to start the selected machine. Click OK if the machine is in operating condition and all personnel are clear of the machine.'
          description='Machine State modal warning text'
        />
      )}
      enable={modalEnable}
      customer={customer}
      pinCode={pinCode}
    />
  )
}

SettingPumpState1.propTypes = {
  device: PropTypes.object,
  status: PropTypes.object,
  level: PropTypes.number,
  customer: PropTypes.object,
  pinCode: PropTypes.object,
}

export const SettingPumpState2 = function SettingPumpState2 ({
  device,
  status,
  level,
  customer,
  pinCode,
  number = 1,
}) {
  const MACHINE_STATE = (
    <FormattedMessage
      id='device.machineState.name'
      defaultMessage='Machine State'
      description='Machine State Label'
    />
  )

  let machineState = '-'
  let tileColorRight = colors.normal
  let machineStateNew = 0
  let machineStateTransition = 0
  const reading0 = device.reading0 || {}
  const runSetting = `run${number}`
  const runSettingConfirm = `X${number === 1 ? 'R' : 'Q'}`
  const controllerStatusAuto = reading0.DI1 > 0 ? 1 : 0
  const applicationSettingsNew = device.application_settings_new || { settings: {} }

  let machineStateIntention = 0
  if (number === 1 && isNumber(reading0.R1)) machineStateIntention = Number(reading0.R1)
  else if (number === 2 && isNumber(reading0.R2)) machineStateIntention = Number(reading0.R2)

  const machineStateRaw = (number === 1) ? reading0.R1S : reading0.R2S

  if (
    applicationSettingsNew &&
    applicationSettingsNew.settings &&
    (
      applicationSettingsNew.settings[runSetting] === 1 ||
      applicationSettingsNew.settings[runSetting] === 0
    )
  ) {
    if (applicationSettingsNew.status === 'new') {
      machineStateNew = applicationSettingsNew.settings[runSetting] ? 1 : 2
      machineStateIntention = applicationSettingsNew.settings[runSetting]
    }
    /*
      This is supposed to cover the transition period between sending stop command
      and it actually getting implemented on the wind machine.
        - command is set in web app, turns red and shows stop
        - device gets command and responds to web, which changes to onDevice
        - device implements command with mpc20 or hauff machine
        - ... time ...
        - device sends follow up reading with new machine state

    */
    if (
      applicationSettingsNew.status === 'onDevice' &&
      ((new Date()).getTime() - (1000 * 65)) < (new Date(applicationSettingsNew.date)).getTime()
    ) {
      machineStateTransition = applicationSettingsNew.settings[runSetting] ? 1 : 2
      machineStateIntention = applicationSettingsNew.settings[runSetting]
    }
  }

  /*

      enum MPC20_STATES {
        STATE_NOT_CONNECTED       = 20,
        STATE_ECU_DELAY           = 0,
        STATE_ENGINE_STOPPED      = 1,
        STATE_CONTROLLER_STANDBY  = 2,
        STATE_PRESTART_DELAY_1    = 3,
        STATE_CHECK_SAFE          = 4,
        STATE_PRESTART_DELAY_2    = 5,
        STATE_CRANK_ON            = 6,
        STATE_CRANK_REST          = 7,
        STATE_FALSE_START         = 8,
        STATE_WARMUP_DELAY        = 9,
        STATE_LINE_FILL_1         = 10,
        STATE_LINE_FILL_2         = 11,
        STATE_RUNNING_LOADED      = 12,
        STATE_COOLDOWN_DELAY      = 13,
        STATE_ENERGIZE_TO_STOP    = 14,
        STATE_SPINDOWN_DELAY      = 15
      };

  */
  const MACHINE_OFF = (
    <FormattedMessage
      id='device.machineState.off'
      defaultMessage='OFF'
      description='OFF State'
    />
  ).valueOf()
  const MACHINE_RUN = (
    <FormattedMessage
      id='device.machineState.run'
      defaultMessage='RUN'
      description='RUN State'
    />
  )
  const MACHINE_START = (
    <FormattedMessage
      id='device.machineState.start'
      defaultMessage='START'
      description='START State'
    />
  )
  const MACHINE_WARMUP = (
    <FormattedMessage
      id='device.machineState.warmUp'
      defaultMessage='WARMUP'
      description='WARMUP State'
    />
  )
  const MACHINE_STOP = (
    <FormattedMessage
      id='device.machineState.stop'
      defaultMessage='STOP'
      description='STOP State'
    />
  )
  const MACHINE_FULLRUN = (
    <FormattedMessage
      id='device.machineState.fullRun'
      defaultMessage='FULL RUN'
      description='FULL RUN State'
    />
  )
  const MACHINE_COOLDOWN = (
    <FormattedMessage
      id='device.machineState.coolDown'
      defaultMessage='COOL DOWN'
      description='COOL DOWN State'
    />
  )
  switch (machineStateRaw) {
    case 0:
    case 1:
    case 2:
      machineState = MACHINE_RUN
      tileColorRight = colors.normal
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_RUN : MACHINE_START
        tileColorRight = machineStateTransition === 2 ? colors.normal : colors.info
      } else if (
        !controllerStatusAuto &&
        (
          (
            device.application_settings &&
            device.application_settings.settings &&
            device.application_settings.settings[runSetting]
          ) || (
            reading0 &&
            reading0[runSettingConfirm] > 0
          )
        )
      ) {
        machineState = MACHINE_RUN
        tileColorRight = colors.danger
        machineStateIntention = 1
      }
      break
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
      machineState = MACHINE_START
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_START
      }
      tileColorRight = colors.info
      break
    case 8:
      machineState = MACHINE_START
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_START
      }
      tileColorRight = colors.danger
      break
    case 9:
      machineState = MACHINE_WARMUP
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_WARMUP
      }
      tileColorRight = colors.info
      break
    case 10:
    case 11:
    case 12:
      machineState = MACHINE_FULLRUN
      tileColorRight = colors.success
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_FULLRUN
        tileColorRight = machineStateTransition === 2 ? colors.info : colors.success
      }
      break
    case 13:
    case 14:
    case 15:
    case 16:
      machineState = MACHINE_STOP
      tileColorRight = colors.info
      if (machineStateTransition) {
        machineState = machineStateTransition === 2 ? MACHINE_STOP : MACHINE_COOLDOWN
        tileColorRight = colors.info
      }
      break
    default:
      machineState = '-'
      tileColorRight = colors.danger
  }

  if (machineStateNew) {
    tileColorRight = colors.deviceProblem
    machineState = machineStateNew === 2 ? MACHINE_STOP : MACHINE_RUN
  }

  let modalEnable = false
  if (level >= 10) {
    modalEnable = true
    if (status.id === 'notConnected') { modalEnable = false }
  }

  if (
    status.id === 'notConnected'
  ) {
    machineState = '-'
    tileColorRight = colors.normal
  }

  return (
    <ModalSetBool2
      key='settingPumpStart'
      name='settingPumpStart'
      textLeft={MACHINE_OFF}
      textRight={machineState}
      textSub='State'
      tileColorLeft={colors.normal}
      tileColorRight={tileColorRight}
      settingCurrentValue={machineStateIntention ? 1 : 0}
      textModal={`Remote ${machineStateIntention === 0 ? 'start' : 'stop'} ${device.physical.deviceNumber}?`}
      textSave={machineStateIntention === 0 ? MACHINE_START : MACHINE_STOP}
      settingName={runSetting}
      settingNewValue={machineStateIntention ? 0 : 1}
      address={reading0.address}
      warning={!machineStateIntention}
      warningText={(
        <FormattedMessage
          id='device.machineState.modalWarning'
          defaultMessage='You are attempting to start the selected machine. Click OK if the machine is in operating condition and all personnel are clear of the machine.'
          description='Machine State modal warning text'
        />
      )}
      enable={modalEnable}
      customer={customer}
      pinCode={pinCode}
    />
  )
}

SettingPumpState2.propTypes = {
  device: PropTypes.object,
  status: PropTypes.object,
  level: PropTypes.number,
  customer: PropTypes.object,
  pinCode: PropTypes.object,
}
